export const ButtonWrapper =
  'font-Roboto text-10 leading-12 tracking-3 cursor-pointer uppercase w-fit w-moz-fit pb-4 md:pb-6 last-of-type:pb-0 hover:text-errorRed transition select-none'

export const ButtonUnderline = `after:mt-1 after:block after:content-[''] after:w-[calc(100%-0.188rem)] after:border-b`

export const ConfirmationHeadline = 'text-black'

export const ConfirmationDescription = 'pt-4 w-full'

export const ConfirmationSerialNo = 'pt-4 pb-1 w-full font-Roboto text-14'

export const ConfirmationNote = 'flex w-full pb-4 text-grayRegular text-12'

export const ConfirmationButtonsWrapper = 'flex w-full pt-4'

export const ConfirmationCancelButton = 'mr-2'
